module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/ar2.jpg";